import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PortalRolesActions } from './portal-roles.actions';
import { map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PortalRolesService } from './services';

@Injectable()
export class PortalRolesEffects {
  constructor(
    private actions$: Actions,
    private portalRolesService: PortalRolesService,
  ) {}

  getPortalRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PortalRolesActions.getPortalRoles),
      switchMap(({ companyId }) =>
        this.portalRolesService.getPortalRoles(companyId),
      ),
      map((portalRoles: any[]) =>
        PortalRolesActions.getPortalRolesSuccess({ portalRoles }),
      ),
      catchError((error) =>
        of(PortalRolesActions.getPortalRolesFailure({ error })),
      ),
    ),
  );
}
